import type {MetaDescriptor} from '@remix-run/node';

interface SeoDefaults {
  title: string;
  description: string;
}

/**
 * Build meta tags for a public page, using SEO overrides from the layout
 * loader data when available, falling back to the provided defaults.
 *
 * Usage in a route's `meta` function:
 * ```
 * export const meta: MetaFunction = function PageMeta({matches}) {
 *   return seoMeta('home', {title: 'Principal - Cindedi', description: '...'}, matches);
 * };
 * ```
 */
export function seoMeta(
  pageKey: string,
  defaults: SeoDefaults,
  matches: Array<{id: string; data: unknown}>,
): MetaDescriptor[] {
  const layoutMatch = matches.find((m) => m.id === 'routes/_public+/_layout');
  const seo = (layoutMatch?.data as {seo?: Record<string, {title: string; description: string}>})
    ?.seo;

  const overrides = seo?.[pageKey];
  const title = overrides?.title || defaults.title;
  const description = overrides?.description || defaults.description;

  return [{title}, {name: 'description', content: description}];
}
